// STYLES
import * as Style from "./DateInputAtomStyle";

// LIBRARIES
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { Dayjs } from "dayjs";

// MISC
import { IProps } from "./DateInputAtomModel";

// ASSETS

// REDUX

// COMPONENTS

const DateInputAtom = (props: IProps) => {
  // PROPS
  const { label = "", value = null, setValue = () => {} } = props;

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleChange = (newValue: Dayjs | null) => {
    setValue(newValue);
  };

  return (
    <Style.DateInputAtomContainer>
      <Style.LabelContainer>{label}</Style.LabelContainer>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputFormat="DD/MM/YYYY"
          value={value === "" ? null : value}
          onChange={handleChange}
          renderInput={(params) => (
            <Style.TextFieldContainer
              {...params}
              inputProps={{
                ...params.inputProps,
                placeholder: "dd/mm/yyyy",
              }}
            />
          )}
        />
      </LocalizationProvider>
    </Style.DateInputAtomContainer>
  );
};

export default DateInputAtom;
